export enum Roles {
    ADMIN = 'admin',
    ORIENTEER = 'orienteer',
    ORIENTED = 'oriented',
}